export default "__VITE_ASSET__fe7ffb04__"